<script lang="ts">
  import { TrendingUp } from "lucide-svelte";
  interface Props {
    conversionRate: number;
    t: (path: string) => string;
  }
  let { conversionRate, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.conversion_rate')}</p>
    <TrendingUp class="h-4 w-4 text-primary" />
  </div>
  <div class="mt-2 flex items-baseline gap-1">
    <span class="text-3xl font-extrabold tracking-tight">{conversionRate}</span>
    <span class="text-xs font-semibold">%</span>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.conversion_rate_tip')}</span>
    <span class="text-emerald-600 font-medium">{t('dashboard.kpi.performance_good')}</span>
  </div>
</div>